import { HateoasResource, Resource } from '@lagoshny/ngx-hateoas-client';
import { AgentDetails } from '../../shared/models/agent-resources/agent-resource';
import { DashboardClientExperienceInvite } from './dashboard-client-experience-invite';
import { DashboardDeal, DealPanelStates } from './dashboard-deal.model';
import { DashboardUser } from './dashboard-user.model';

@HateoasResource('dashboard')
export class DashboardView extends Resource {
  agent: AgentDetails;
  ceInvites: DashboardClientExperienceInvite[];
  deals: DashboardDeal[];
  user: DashboardUser;

  filterDealsByProgressState(panelState: DealPanelStates): DashboardDeal[] {
    return this.deals.filter(d => d.panelState == panelState);
  }
}
